export const STATUS_VARIANTS = {
  PENDING: 'pending-approval',
  AWAITING: 'awaiting-approval',
  APPROVED: 'approved',
  DISABLED: 'workflow-disabled',
  UNKNOWN: 'unknown-status',
  LOCAL_REJECTED: 'local-commentary-rejected',
  LOCAL_AWAITED: 'local-commentary-awaited',
  LOCAL_PENDING: 'local-commentary-awaiting-approval',
  REGIONAL_AWAITED: 'regional-commentary-awaited',
  REGIONAL_PENDING: 'regional-commentary-awaiting-approval',
  REGIONAL_REJECTED: 'regional-commentary-rejected',
  COMMENTARY_APPROVED: 'commentary-approved',
  COMMENTARY_NIL: 'commentary-nil',
  COMMENTARY_IMMATERIAL: 'commentary-immaterial',
  COMMENTARY_NOT_IN_SCOPE: 'commentary-not-in-scope',
  OPEN: 'open',
  REJECTED: 'rejected',
  IN_PROGRESS: 'in-progress',
  FAILED: 'failed',
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  GENERATING: 'generating',
  READY: 'ready',
};

export const STATUS_CONFIG = {
  [STATUS_VARIANTS.PENDING]: {
    label: 'In Local Review',
    color: 'var(--workflow-yellow-local)',
  },
  [STATUS_VARIANTS.AWAITING]: {
    label: 'In Local Review',
    color: 'var(--workflow-yellow-local)',
  },
  [STATUS_VARIANTS.APPROVED]: {
    label: 'Approved',
    color: 'var(--workflow-green)',
  },
  [STATUS_VARIANTS.DISABLED]: {
    label: 'Workflow Disabled',
    color: 'var(--workflow-disabled)',
  },
  [STATUS_VARIANTS.UNKNOWN]: {
    label: 'No Status',
    color: 'var(--workflow-other-text)',
  },
  [STATUS_VARIANTS.LOCAL_REJECTED]: {
    label: 'Local Rejected',
    color: 'var(--workflow-red-local)',
  },
  [STATUS_VARIANTS.LOCAL_AWAITED]: {
    label: 'In Local Submission',
    color: 'var(--workflow-blue-local)',
  },
  [STATUS_VARIANTS.LOCAL_PENDING]: {
    label: 'In Local Review',
    color: 'var(--workflow-yellow-local)',
  },
  [STATUS_VARIANTS.REGIONAL_AWAITED]: {
    label: 'In Regional Submission',
    color: 'var(--workflow-blue-regional)',
  },
  [STATUS_VARIANTS.REGIONAL_PENDING]: {
    label: 'In Regional Review',
    color: 'var(--workflow-yellow-regional)',
  },
  [STATUS_VARIANTS.REGIONAL_REJECTED]: {
    label: 'Regional Rejected',
    color: 'var(--workflow-red-regional)',
  },
  [STATUS_VARIANTS.COMMENTARY_APPROVED]: {
    label: 'Approved',
    color: 'var(--workflow-green)',
  },
  [STATUS_VARIANTS.COMMENTARY_NIL]: {
    label: 'Nil Value Accounts',
    color: 'var(--workflow-disabled)',
  },
  [STATUS_VARIANTS.COMMENTARY_IMMATERIAL]: {
    label: 'Immaterial Variance',
    color: 'var(--workflow-disabled)',
  },
  [STATUS_VARIANTS.COMMENTARY_NOT_IN_SCOPE]: {
    label: 'Not in Scope',
    color: 'var(--workflow-disabled)',
  },
  [STATUS_VARIANTS.OPEN]: {
    label: 'Open',
    color: 'var(--workflow-blue-local)',
  },
  [STATUS_VARIANTS.REJECTED]: {
    label: 'Rejected',
    color: 'var(--workflow-red-local)',
  },
  [STATUS_VARIANTS.IN_PROGRESS]: {
    label: 'In Progress',
    color: 'var(--workflow-yellow-regional)',
  },
  [STATUS_VARIANTS.FAILED]: {
    label: 'Failed',
    color: 'var(--workflow-red-regional)',
  },
  [STATUS_VARIANTS.ACTIVE]: {
    label: 'Active',
    color: 'var(--workflow-green)',
  },
  [STATUS_VARIANTS.INACTIVE]: {
    label: 'Inactive',
    color: 'var(--workflow-other-text)',
  },
  [STATUS_VARIANTS.GENERATING]: {
    label: 'Generating',
    color: 'var(--workflow-yellow-local)',
  },
  [STATUS_VARIANTS.READY]: {
    label: 'Ready',
    color: 'var(--workflow-green)',
  },
};

export const STATUS_CODE_VARIANT_MAP = {
  0: STATUS_VARIANTS.PENDING,
  1: STATUS_VARIANTS.AWAITING,
  2: STATUS_VARIANTS.APPROVED,
  3: STATUS_VARIANTS.DISABLED,
};
export const STATUS_CODE_VARIANT_MAP_REGIONAL = {
  0: STATUS_VARIANTS.REGIONAL_PENDING,
  1: STATUS_VARIANTS.REGIONAL_AWAITED,
  2: STATUS_VARIANTS.APPROVED,
  3: STATUS_VARIANTS.DISABLED,
};

export const DEFAULT_STATUS_VARIANT = STATUS_VARIANTS.APPROVED;

export const COMMENTARY_STAGE_VARIANT_MAP = {
  '-2': STATUS_VARIANTS.REGIONAL_REJECTED,
  '-1': STATUS_VARIANTS.LOCAL_REJECTED,
  '0': STATUS_VARIANTS.LOCAL_AWAITED,
  '1': STATUS_VARIANTS.LOCAL_PENDING,
  '2': STATUS_VARIANTS.LOCAL_PENDING,
  '3': STATUS_VARIANTS.COMMENTARY_NIL,
  '4': STATUS_VARIANTS.COMMENTARY_IMMATERIAL,
  '5': STATUS_VARIANTS.REGIONAL_AWAITED,
  '6': STATUS_VARIANTS.REGIONAL_PENDING,
  '7': STATUS_VARIANTS.COMMENTARY_APPROVED,
  '9': STATUS_VARIANTS.COMMENTARY_NOT_IN_SCOPE,
};

export const COMMENTARY_STAGE_LABEL_MAP = {
  '-2': {
    labelNamespace: 'cycle_page',
    labelKey: 'commentary_filter_regional_commentary_rejected',
    fallback: 'Regional Rejected',
  },
  '-1': {
    labelNamespace: 'cycle_page',
    labelKey: 'commentary_filter_local_commentary_rejected',
    fallback: 'Local Rejected',
  },
  '0': {
    labelNamespace: 'cycle_page',
    labelKey: 'commentary_filter_local_commentary_awaited',
    fallback: 'In Local Submission',
  },
  '1': {
    labelNamespace: 'cycle_page',
    labelKey: 'commentary_filter_local_commentary_awaiting_approval',
    fallback: 'In Local Review',
  },
  '2': {
    labelNamespace: 'cycle_page',
    labelKey: 'commentary_filter_local_commentary_awaiting_approval',
    fallback: 'In Local Review',
  },
  '3': {
    labelNamespace: 'cycle_page',
    labelKey: 'commentary_filter_nil_value_accounts_label',
    fallback: 'Nil value accounts',
  },
  '4': {
    labelNamespace: 'cycle_page',
    labelKey: 'commentary_filter_immaterial_variance_label',
    fallback: 'Immaterial variance',
  },
  '5': {
    labelNamespace: 'cycle_page',
    labelKey: 'commentary_filter_regional_commentary_awaited',
    fallback: 'In Regional Submission',
  },
  '6': {
    labelNamespace: 'cycle_page',
    labelKey: 'commentary_filter_regional_commentary_awaiting_approval',
    fallback: 'In Regional Review',
  },
  '7': {
    labelNamespace: 'cycle_page',
    labelKey: 'commentary_filter_approved_label',
    fallback: 'Approved',
  },
  '9': {
    labelNamespace: 'cycle_page',
    labelKey: 'commentary_filter_not_in_scope_label',
    fallback: 'Not in Scope',
  },
};

export const COMMENTARY_STAGE_DEFAULT = {
  variant: STATUS_VARIANTS.UNKNOWN,
  labelNamespace: 'cycle_page',
  labelKey: 'commentary_filter_not_in_scope_label',
  fallback: 'Status unavailable',
};

